import { TextFilter } from 'src/components/Filters/TextFilter';
import { TextFilterQuery } from 'src/components/Filters/TextFilter/TextFilter';

export const InternalNotesFilter = <TQuery extends TextFilterQuery>({
  query,
  setQuery,
  isHorizontalLayout,
}: {
  query: TQuery;
  setQuery: (q: TQuery) => void;
  isHorizontalLayout?: boolean;
}) => {
  return (
    <TextFilter
      query={query}
      setQuery={setQuery}
      keys={{
        textContainsKey: 'internalNotesContains',
        textNotContainsKey: 'internalNotesNotContains',
        textEqualsKey: 'internalNotesEquals',
      }}
      isHorizontalLayout={isHorizontalLayout}
    />
  );
};
